import { FaUserCircle } from 'react-icons/fa';

import { FLButton } from '@shared/ui';

import { useLogin } from './hooks';
import { buttonClasses } from './Button.tailwind';

const LoginButton = () => {
  const { getGoogleResponse } = useLogin();

  const handleLogin = () => {
    getGoogleResponse();
  };

  return (
    <FLButton
      type="primary"
      text="Login"
      classes={buttonClasses}
      icon={<FaUserCircle />}
      onClick={handleLogin}
      data-id="button-Login"
    />
  );
};

export default LoginButton;
